module.exports = __webpack_public_path__ + "img/logo-icon.89074da9.png";